export const TABLES_KEYS = Object.freeze({
  dailyPlan: 'daily-plan',
  taskChangeLog: 'daily-plan-task-change-log'
});
